import React, { useState, useCallback, useEffect } from 'react';
import Divider from '@material-ui/core/Divider';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ReportIcon from '@material-ui/icons/Report';
import CreateIcon from '@material-ui/icons/Create';
import Collapse from '@material-ui/core/Collapse';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import Badge from '@material-ui/core/Badge';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { paths } from '../../routes';
import { useApi, useRoutes } from '../../hooks';
import logo from '../../assets/leo-logo.png';

const rapportsRoutes = [
  paths.asct,
  paths.security,
  paths.safety,
  paths.versement,
  paths.proprete,
  paths.avitaillement,
  paths.prmAssistance,
  paths.bulletincomposition,
  paths.restauration
];

const useStyles = makeStyles((theme) => ({
  // necessary for content to be below app bar
  toolbar: {
    ...theme.mixins.toolbar,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
  logo: {
    width: 80,
  },
}));

const StyledBadge = withStyles((theme) => ({
  badge: {
    right: -18,
    top: 10,
  },
}))(Badge);

type MenuItemProps = {
  path: string;
  label: string;
  icon?: React.ReactNode;
  badge?: string;
  onChange: Function;
  className?: string;
};

const MenuItem: React.FC<MenuItemProps> = ({
  path,
  label,
  icon,
  onChange,
  badge,
  className,
}: MenuItemProps) => {
  const history = useHistory();
  const selected = useRouteMatch({
    path,
  });

  const handleOnItemClick = useCallback(() => {
    onChange();
    history.push(path);
  }, [history, path, onChange]);

  return (
    <ListItem
      key={path}
      className={className}
      onClick={handleOnItemClick}
      selected={!!selected}
      button
    >
      {icon && <ListItemIcon>{icon}</ListItemIcon>}
      <ListItemText
        primary={
          <StyledBadge color="secondary" badgeContent={badge} max={9999}>
            {label}
          </StyledBadge>
        }
      />
    </ListItem>
  );
};

type SidebarMenuProps = {
  onChange: () => void;
};

const SidebarMenu: React.FC<SidebarMenuProps> = ({ onChange }: SidebarMenuProps) => {
  const classes = useStyles();
  const [open, setOpen] = React.useState(true);
  const [unreadReports, setUnreadReports] = useState<any>({});
  const { getSumUnreadReport } = useApi();
  const { currentPathname } = useRoutes();

  const handleClick = () => {
    setOpen(!open);
  };

  useEffect(() => {
    if (!currentPathname) return;
    (async () => {
      try {
        const response: any = await getSumUnreadReport();
        const unreadReports = (response || []).reduce(
          (acc: any, next: any) => ({ ...acc, [next.themeShortCode]: next.sumUnreadReports }),
          []
        );
        setUnreadReports(unreadReports);
      } catch (error) {}
    })();
  }, [getSumUnreadReport, currentPathname]);

  return (
    <div>
      <div className={classes.toolbar}>
        <img src={logo} className={classes.logo} alt="logo" />
      </div>
      <Divider />
      <List component="nav">
        <ListItem button onClick={handleClick}>
          <ListItemIcon>
            <ReportIcon />
          </ListItemIcon>
          <ListItemText primary="Rapports" />
          {open ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
        <Collapse in={open} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {rapportsRoutes.map((route) => (
              <MenuItem
                key={route.path}
                path={route.path}
                label={route.label}
                badge={unreadReports[route.themeShortCode || '']}
                onChange={onChange as any}
                className={classes.nested}
              />
            ))}
          </List>
        </Collapse>
        <MenuItem
          icon={<CreateIcon />}
          label={paths.emargement.label}
          path={paths.emargement.path}
          onChange={onChange as any}
        />
      </List>
    </div>
  );
};

export default SidebarMenu;
